exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-actions>div>.btn[data-v-3ceb38c6]{font-size:1.9rem!important}.day-row>.row[data-v-3ceb38c6]{margin-left:0;margin-right:0}.day-row>.row>div[data-v-3ceb38c6]{box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03);border-radius:.25rem;cursor:pointer;border:0;margin-bottom:10px}.list-group-item[data-v-3ceb38c6]{background-color:transparent;border:0}.content-body[data-v-3ceb38c6]{height:100%}.day-row>.row.read>div[data-v-3ceb38c6]{background-color:transparent;color:#fff}.day-row>.row.unread>div[data-v-3ceb38c6]{background-color:#ff0}", ""]);

// exports
